export const NOTIFICATIONS_CHANNEL_TYPES = [
  "user",
  "company",
  "manager",
  "admin",
  "branch",
] as const;

export type NotificationsChannelType = (typeof NOTIFICATIONS_CHANNEL_TYPES)[number];

export const DEFAULT_NOTIFICATIONS_CHANNEL_TYPE: NotificationsChannelType = "admin";

export const buildNotificationsChannelName = (
  type: NotificationsChannelType,
  id: string
) => `${type}.${id}`;

export const resolveNotificationsChannelType = (
  config?: string
): NotificationsChannelType => {
  if (!config) {
    return DEFAULT_NOTIFICATIONS_CHANNEL_TYPE;
  }

  const normalized = config.trim().toLowerCase();
  const matched = NOTIFICATIONS_CHANNEL_TYPES.find((type) => type === normalized);
  return matched ?? DEFAULT_NOTIFICATIONS_CHANNEL_TYPE;
};
